module.exports = __webpack_public_path__ + "static/media/vendor.134adaae.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/pic/vendor.PNG
// module id = 565
// module chunks = 0